import { retryButtonText } from 'owa-locstrings/lib/strings/retrybuttontext.locstring.json';
import { missingCertificateDialogHeader } from './MissingCertificateDialog.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import MissingCertificateDetails from './MissingCertificateDetails';
import { confirm, ConfirmCustomizationOptions, DialogResponse } from 'owa-confirm-dialog';

const styles = require('./MissingCertificateDialog.scss');

/**
 * Function which displays the missing certificates popup
 */
const showMissingCertificateDialog = (
    recipients: EmailAddressWrapper[]
): Promise<DialogResponse> => {
    const customizationOptions: ConfirmCustomizationOptions = {
        bodyElement: <MissingCertificateDetails recipientsToDisplay={recipients} />,
        okText: loc(retryButtonText),
        showContinueButton: true,
        containerClassName: styles.missingCertificatesContainer,
    };

    return confirm(
        loc(missingCertificateDialogHeader),
        null /*subText*/,
        false /*resolveImmediately*/,
        customizationOptions
    );
};

export default showMissingCertificateDialog;
